
import Main from "@/views/Main.vue";
const customerRoutes = [
  {
    path: "/exchange",
    icon: "android-menu",
    name: "exchange",
    title: "汇率管理",
    component: Main,
    children: [
      {
        path: "rate",
        title: "汇率兑换",
        name: "rate",
        component: resolve => {
          require(["@/views/exchange/cn/rate/list.vue"], resolve);
        }
      },
      {
        path: "currency",
        title: "货币管理",
        name: "currency",
        component: resolve => {
          require(["@/views/exchange/cn/currency.vue"], resolve);
        }
      },
      {
        path: "country",
        title: "国家和汇率",
        name: "CountryRate",
        component: resolve => {
          require(["@/views/exchange/cn/country.vue"], resolve);
        }
      },
      {
        path: "invoiceExport",
        title: "买手店发票导出",
        name: "InvoiceExport",
        component: resolve => {
          require(["@/views/exchange/cn/invoiceExport.vue"], resolve);
        }
      },
    ]
  },
]

export default customerRoutes
